import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const callbackResponses = {
  200: z.literal('ok'),
  401: z.literal('unauthorized'),
  404: z.literal('not found'),
} as const;

export const frCustomsContract = c.router({
  receiveDeltaIeCallback: {
    method: 'POST',
    path: '/fr-customs/delta-ie/:messageType',
    pathParams: z.object({ messageType: z.string() }),
    body: z.any(),
    responses: callbackResponses,
  },
  receiveDeltaTCallback: {
    method: 'POST',
    path: '/fr-customs/delta-t/:messageType',
    pathParams: z.object({ messageType: z.string() }),
    body: z.any(),
    responses: callbackResponses,
  },
  receiveH7DeclarationsCallback: {
    method: 'POST',
    path: '/fr-customs/h7/declarations/:code',
    pathParams: z.object({ code: z.string() }),
    body: z.any(),
    responses: callbackResponses,
  },
  receiveH7DeclarationsWithRefCallback: {
    method: 'POST',
    path: '/fr-customs/h7/declarations/:ref/:code',
    pathParams: z.object({ ref: z.string(), code: z.string() }),
    body: z.any(),
    responses: callbackResponses,
  },
});
